import { MasterReducer, Generator } from '../../utils/store';
import { call, put, select } from 'redux-saga/effects';

import * as Auths from '../../utils/auth';
import * as Functions from '../../utils/functions';

const key = 'app';

export const Reducer = new MasterReducer(
  key,
  {
    authUser: false,
    location: false,
    webSocket: false,
    isWebSocketConnected: false,
    systemSetting: false,
    articleCategories: [],
  },
  {
    ...Generator.makeObjectModelActions('authUser', 'loadAuthUser', function* (returnAction, self) {
      try {
        const values = yield select(self.makeSelector('values'));
        const bearerAccessToken = values?.bearerAccessToken ? values?.bearerAccessToken : Auths.getBearerAccessToken();

        const response = yield call(
          Functions.Request.makeRequestCall,
          'GET',
          'auth/user',
          {
            bearerAccessToken: bearerAccessToken,
          }
        );

        if (response.result) {
          Auths.setUser(response.data);
          if (values?.reloadCallback) {
            values?.reloadCallback(response.data);
          }
        }
        else {
          Auths.removeTokens();
          Auths.removeUser();
        }

        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeActions('updateAuthUser', function* (returnAction, self) {
      try {
        const values = yield select(self.makeSelector('values'));

        const response = yield call(
          Functions.Request.makeRequestCall,
          'PUT',
          'auth/user',
          {
            body: {
              ...values,
              avatar: values.avatar?.id
            },
          }
        );

        if (response.result) {
          if (values.reloadCallback) {
            values.reloadCallback(response);
          }
          yield put(self.actionCreators.loadAuthUser());
        }

        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeActions('updateAuthUserPassword', function* (returnAction, self) {
      try {
        var values = yield select(self.makeSelector('values'));

        const response = yield call(
          Functions.Request.makeRequestCall,
          'PUT',
          'auth/user/update-password',

          {
            body: values,
          }
        );

        if (response.result) {
          if (values.reloadCallback) {
            values.reloadCallback(response);
          }
          yield put(self.actionCreators.loadAuthUser());
        }

        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeActions('signOut', function* (returnAction, self) {
      try {
        const response = yield call(
          Functions.Request.makeRequestCall,
          'POST',
          'auth/sign-out',
          {
            body: {},
          }
        );

        Auths.removeTokens();
        Auths.removeUser();
        if (response.result) {
          window.location.href = '/';
        }

        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeObjectModelActions('webSocket', 'initializeWebSocket', function* (returnAction, self) {
      try {
        const values = yield select(self.makeSelector('values'));

        const newWebSocket = yield call(
          Functions.WebSocketer.createConnection,
          process.env.REACT_APP_WEB_SOCKET_ENDPOINT + '?Authorization=' + Auths.getAccessToken(),
          values
        );

        newWebSocket.onclose = () => {
          console.log('WebSocket has been closed!');
          console.log('Reconnecting in 3s');
          setTimeout(() => {
            self.dispatcher.initializeWebSocket();
          }, 3000);
        };

        newWebSocket.onerror = (err) => {
          console.log('WebSocket error!', err);
          console.log('Reconnecting in 3s');
          setTimeout(() => {
            self.dispatcher.initializeWebSocket();
          }, 3000);
        };

        newWebSocket.sendRequest = (action, data) => {
          newWebSocket.send(JSON.stringify({
            Authorization: Auths.getAccessToken(),
            action: action,
            data: data,
          }))
        };

        yield put(returnAction({
          result: true,
          data: newWebSocket,
        }));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeObjectModelActions('systemSetting', 'loadSystemSetting', function* (returnAction, self) {
      try {
        const response = yield call(
          Functions.Request.makeRequestCall,
          'GET',
          'system-settings',
        );

        if (response.result) {
          Auths.setSystemSetting(response.data);
          Auths.setIsMaintenance(response.data.isMaintenance);
        }
    
        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),

    ...Generator.makeArrayModelActions('articleCategories', 'loadArticleCategories', function* (returnAction, self) {
      try {
        const response = yield call(
          Functions.Request.makeRequestCall,
          'GET',
          'article-categories',
        );
    
        yield put(returnAction(response));
      } catch (e) {
        console.error('error', e);
        yield put(returnAction(e));
      }
    }),
  },
  true
);

export default Reducer;

export const reducer = Reducer.reducer;
export const saga = Reducer.saga;